function sortedPackages(packages) {
  return [...(packages || [])]
    .filter((p) => Number(p.credits) > 0 && Number(p.price) > 0)
    .sort((a, b) => Number(a.credits) - Number(b.credits));
}

/** Belépő csomag Ft/kredit (összehasonlításhoz). */
export function customCreditUnitPriceFromPackages(packages) {
  const list = sortedPackages(packages);
  if (!list.length) return 10;
  const smallest = list[0];
  return Math.max(1, Math.ceil(Number(smallest.price) / Number(smallest.credits)));
}

/**
 * Egyedi mennyiség ára — csomagsáv szerint (500 kredit = 500-as csomag ára).
 * Backend: _custom_credit_purchase_price
 */
export function customCreditPurchasePrice(packages, credits) {
  const amount = Math.floor(Number(credits));
  if (!Number.isFinite(amount) || amount <= 0) return 0;
  const list = sortedPackages(packages);
  if (!list.length) return amount * 10;

  const exact = list.find((p) => Number(p.credits) === amount);
  if (exact) return Number(exact.price);

  let tier = list[0];
  for (const p of list) {
    if (Number(p.credits) <= amount) tier = p;
  }
  const rate = Number(tier.price) / Number(tier.credits);
  return Math.max(1, Math.round(amount * rate));
}

export function customCreditEffectiveUnitPrice(packages, credits) {
  const amount = Math.floor(Number(credits));
  if (amount <= 0) return 0;
  const total = customCreditPurchasePrice(packages, amount);
  return total / amount;
}
